import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import "./StudentMentorDetails.css";

const emptyMentor = {
  mentorName: "",
  contactNo: "",
  emailId: "",
};

const MentorDetail = () => {
  const navigate = useNavigate();
  const [mentorData, setMentorData] = useState(emptyMentor);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchMentorDetails = async () => {
      const studentId = sessionStorage.getItem("userId");
      const academicYearId = localStorage.getItem("academicSessionId") || "";
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      if (!studentId) {
        setError("Student session details are missing. Please log in again.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const queryParams = new URLSearchParams();
        if (academicYearId) queryParams.append("academic_year_id", academicYearId);
        if (orgId) queryParams.append("org_id", orgId);
        if (branchId) queryParams.append("branch_id", branchId);

        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentMentor/${studentId}/?${queryParams.toString()}`
        );

        const contentType = response.headers.get("content-type") || "";
        const payload = contentType.includes("application/json")
          ? await response.json()
          : null;

        if (!response.ok || !payload || payload.message !== "Success") {
          throw new Error(payload?.message || "Unable to load mentor details.");
        }

        const mentor = payload.data || {};
        setMentorData({
          mentorName: mentor.mentor_name || "-",
          contactNo: mentor.contact_no || "-",
          emailId: mentor.email_id || "-",
        });
      } catch (fetchError) {
        console.error("Error fetching mentor details:", fetchError);
        setMentorData(emptyMentor);
        setError(fetchError.message || "Unable to load mentor details.");
      } finally {
        setLoading(false);
      }
    };

    fetchMentorDetails();
  }, []);

  return (
    <div className="container-fluid student-mentor-page">
      <div className="row">
        <div className="col-12">
          <div className="student-mentor-shell">
            <div className="student-mentor-header">
              <button
                type="button"
                className="btn btn-danger student-mentor-close"
                onClick={() => navigate("/student/dashboards")}
              >
                Close
              </button>
              <h2 className="student-mentor-title">MENTOR DETAILS</h2>
            </div>

            <div className="student-mentor-card">
              {loading ? (
                <div className="text-center py-4">Loading mentor details...</div>
              ) : error ? (
                <div className="alert alert-danger mb-0">{error}</div>
              ) : (
                <Form>
                  <Row className="student-mentor-row align-items-center">
                    <Col md={3} className="student-mentor-label-wrap">
                      <Form.Label className="student-mentor-label">
                        Mentor Name:
                      </Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        value={mentorData.mentorName}
                        disabled
                        className="student-mentor-input"
                      />
                    </Col>
                  </Row>

                  <Row className="student-mentor-row align-items-center">
                    <Col md={3} className="student-mentor-label-wrap">
                      <Form.Label className="student-mentor-label">
                        Mentor Email:
                      </Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        value={mentorData.emailId}
                        disabled
                        className="student-mentor-input"
                      />
                    </Col>
                  </Row>

                  <Row className="student-mentor-row align-items-center mb-0">
                    <Col md={3} className="student-mentor-label-wrap">
                      <Form.Label className="student-mentor-label">
                        Mentor Phone:
                      </Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        value={mentorData.contactNo}
                        disabled
                        className="student-mentor-input"
                      />
                    </Col>
                  </Row>
                </Form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentorDetail;
